import { render } from "./FooterStyleTwo.vue?vue&type=template&id=8c3146dc"
import script from "./FooterStyleTwo.vue?vue&type=script&lang=js"
export * from "./FooterStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__